import React from 'react';
import { useParams } from 'react-router-dom';

import HomeCMS from './HomeCMS';
import AboutCMS from './AboutCMS';
import ContactUsCMS from './ContactUsCMS';
import FunctionalityCMS from './FunctionalityCMS';
import ResourcesCMS from './ResourcesCMS';
import ProductListCMS from './ProductListCMS';
import ProductDetailCMS from './ProductDetailCMS';
import CartCMS from './CartCMS';
import CheckoutCMS from './CheckoutCMS';
import ThankYouCMS from './ThankYouCMS';

const CMSWrapper = () => {
    const { code } = useParams();

    switch (code) {
        case 'home':
            return <HomeCMS />;
        case 'contact_us':
            return <ContactUsCMS />;
        case 'about':
            return <AboutCMS />;
        case 'functionality':
            return <FunctionalityCMS />;
        case 'resources':
            return <ResourcesCMS />;
        case 'product_list':
            return <ProductListCMS />;
        case 'product_detail':
            return <ProductDetailCMS />;
        case 'cart':
            return <CartCMS />;
        case 'checkout':
            return <CheckoutCMS />;
        case 'thankyou':
            return <ThankYouCMS />;
        default:
            return <div>Invalid CMS page: <strong>{code}</strong></div>;
    }
};

export default CMSWrapper;
